<template>
  <div class="dashboard">
    <ccs-header :title="'Мои проекты и КТ'"/>
    <div class="dashboard-content">
      <div class="dashboard-navbar">
        <ccs-input type="dropdown" class="navbar-mode" :items="modes"
          v-model="mode" placeholder="Выберите поле" :modifiers="['no_cancel']" @select="onModeSelect"/>
        <ccs-input v-model="contextEventId" type="autocomplete" :items="eventsForSelect"
          placeholder="Поиск мероприятия" @change="onEventSearch"/>
      </div>
      <div v-if="!isEventContext">
        <div class="dashboard-subtitle">Выберите мероприятие</div>
      </div>
      <div v-if="isEventContext && mode === 'control_points' && notifications.length === 0 && control_points.length === 0 &&
        relatedToMeControlPointsCount === 0 && allControlPointsCount === 0">
        <div class="dashboard-subtitle">Нет данных для отображения</div>
      </div>
      <div v-if="isEventContext && mode === 'projects' && notifications.length === 0 && projects.length === 0">
        <div class="dashboard-subtitle">Нет данных для отображения</div>
      </div>
      <div class="dashboard-notifications" v-if="isEventContext && notifications.length > 0">
        <div class="dashboard-title">Новости мероприятия</div>
        <div class="dashboard-notifications-block" v-if="manualNotifications.length > 0">
          <div class="block-content">
            <div class="dashboard-notification" v-for="notification in manualNotifications" :key="`mn-${notification.id}`"
              @click="openNotificationByID(notification.id)">
              <div class="notification-row notification-row--tags">
                <div class="ccs-tag ccs-tag--small ccs-tag--light ccs-tag--no_action">
                  {{ stringDateToText(notification.created_at) }}
                </div>
              </div>
              <div class="notification-row--message">
                {{ notification.message }}
              </div>
            </div>
          </div>
        </div>
        <div class="dashboard-notifications-block" v-if="automatedNotifications.length > 0">
          <div class="dashboard-subtitle">Уведомления</div>
          <div class="block-content">
            <div class="dashboard-notification" v-for="notification in automatedNotifications" :key="`mn-${notification.id}`"
              @click="openNotificationByID(notification.id)">
              <div class="notification-row notification-row--tags">
                <div class="ccs-tag ccs-tag--small ccs-tag--light ccs-tag--no_action">
                  {{ stringDateToText(notification.created_at) }}
                </div>
              </div>
              <div class="notification-row--message_short">
                {{ getNotificationMessage(notification) }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="dashboard-title" v-if="mode === 'control_points' && isEventContext &&
        (control_points.length > 0 || relatedToMeControlPointsCount > 0 || allControlPointsCount > 0)">
        Контрольные точки
      </div>
      <div class="dashboard-control_points-stats" v-if="mode === 'control_points' && isEventContext &&
        (relatedToMeControlPointsCount > 0 || allControlPointsCount > 0)">
        <dashboard-control-points-pie-chart-container v-if="relatedToMeControlPointsCount > 0"
            :data="control_points_stats.related_to_me" name="Мои КТ"/>
        <dashboard-control-points-pie-chart-container v-if="allControlPointsCount > 0"
            :data="control_points_stats.all" name="КТ мероприятия"/>
      </div>
      <div class="dashboard-control_points" v-if="mode === 'control_points' && isEventContext && control_points.length > 0">
        <div class="dashboard-control_points-block" v-if="waitingForApprovalList.length > 0">
          <div class="dashboard-subtitle">Ожидают подтверждения</div>
          <div class="block-content">
            <div class="dashboard-control_point" v-for="controlPoint in waitingForApprovalList" :key="`wfa-${controlPoint.id}`"
              @click="openControlPointByID(controlPoint.id)">
              <div class="control_point-row control_point-row--tags">
                <div v-if="controlPoint.type === 'critical'" class="ccs-tag ccs-tag--small ccs-tag--light ccs-tag--no_action">
                  Критическая
                </div>
                <div v-else class="ccs-tag ccs-tag--small ccs-tag--light ccs-tag--no_action">
                  Функциональная
                </div>
                <div v-if="!controlPoint.completed_at &&
                  new Date(controlPoint.expired_at).getTime() - Date.now() < 604800000 &&
                  new Date(controlPoint.expired_at).getTime() - Date.now() > 0"
                  class="ccs-tag ccs-tag--small ccs-tag--light ccs-tag--warn ccs-tag--no_action">
                  Истекает срок
                </div>
                <div v-if="!controlPoint.completed_at && new Date(controlPoint.expired_at).getTime() - Date.now() <= 0"
                  class="ccs-tag ccs-tag--small ccs-tag--light ccs-tag--danger ccs-tag--no_action">
                  Срок истек
                </div>
              </div>
              <div class="control_point-row control_point-row--header">
                <div class="control_point-title">{{ controlPoint.name }}</div>
              </div>
            </div>
          </div>
        </div>
        <div class="dashboard-control_points-block" v-if="inProgressList.length > 0">
          <div class="dashboard-subtitle">Выполняются</div>
          <div class="block-content">
            <div class="dashboard-control_point" v-for="controlPoint in inProgressList" :key="`wfa-${controlPoint.id}`"
              @click="openControlPointByID(controlPoint.id)">
              <div class="control_point-row control_point-row--tags">
                <div v-if="controlPoint.type === 'critical'" class="ccs-tag ccs-tag--small ccs-tag--light ccs-tag--no_action">
                  Критическая
                </div>
                <div v-else class="ccs-tag ccs-tag--small ccs-tag--light ccs-tag--no_action">
                  Функциональная
                </div>
                <div v-if="!controlPoint.completed_at &&
                  new Date(controlPoint.expired_at).getTime() - Date.now() < 604800000 &&
                  new Date(controlPoint.expired_at).getTime() - Date.now() > 0"
                  class="ccs-tag ccs-tag--small ccs-tag--light ccs-tag--warn ccs-tag--no_action">
                  Истекает срок
                </div>
                <div v-if="!controlPoint.completed_at && new Date(controlPoint.expired_at).getTime() - Date.now() <= 0"
                  class="ccs-tag ccs-tag--small ccs-tag--light ccs-tag--danger ccs-tag--no_action">
                  Срок истек
                </div>
              </div>
              <div class="control_point-row control_point-row--header">
                <div class="control_point-title">{{ controlPoint.name }}</div>
              </div>
            </div>
          </div>
        </div>
        <div class="dashboard-control_points-block" v-if="inClosureProcessList.length > 0">
          <div class="dashboard-subtitle">В процессе закрытия</div>
          <div class="block-content">
            <div class="dashboard-control_point" v-for="controlPoint in inClosureProcessList" :key="`incp-${controlPoint.id}`"
              @click="openControlPointByID(controlPoint.id)">
              <div class="control_point-row control_point-row--tags">
                <div v-if="controlPoint.type === 'critical'" class="ccs-tag ccs-tag--small ccs-tag--light ccs-tag--no_action">
                  Критическая
                </div>
                <div v-else class="ccs-tag ccs-tag--small ccs-tag--light ccs-tag--no_action">
                  Функциональная
                </div>
                <div v-if="!controlPoint.completed_at &&
                  new Date(controlPoint.expired_at).getTime() - Date.now() < 604800000 &&
                  new Date(controlPoint.expired_at).getTime() - Date.now() > 0"
                  class="ccs-tag ccs-tag--small ccs-tag--light ccs-tag--warn ccs-tag--no_action">
                  Истекает срок
                </div>
                <div v-if="!controlPoint.completed_at && new Date(controlPoint.expired_at).getTime() - Date.now() <= 0"
                  class="ccs-tag ccs-tag--small ccs-tag--light ccs-tag--danger ccs-tag--no_action">
                  Срок истек
                </div>
              </div>
              <div class="control_point-row control_point-row--header">
                <div class="control_point-title">{{ controlPoint.name }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="dashboard-title" v-if="mode === 'projects' && isEventContext && projects.length > 0">
        Проекты
      </div>
      <div class="dashboard-projects" v-if="mode === 'projects' && isEventContext">
        <div v-for="project in projects" :key="project.id"
          class="dashboard-project"
          @click="goToProjectPage(project)">
          <div class="project-progress" :style="{ 'clip-path': `polygon(0 0, ${project.completeness * 100}% 0, ${project.completeness * 100}% 100%, 0 100%)` }">
            <div class="project-info">
              <div class="project-title">
                {{ project.name }}
              </div>
              <div class="project-date">
                {{ stringDateToText(project.created_at) }}
              </div>
            </div>
            <div class="project-responsibles">
              <div class="project-title">
                Ответственные
              </div>
              <div class="responsibles" v-if="!!project.responsible">
                <div class="ccs-tag ccs-tag--normal" v-for="(item, index) in project.responsible.data" :key="index">
                  {{ item.full_name }}
                </div>
              </div>
              <div v-else>
                Не назначены
              </div>
            </div>
            <div class="project-responsible_fnd">
              <div class="project-title">
                Ответственный ФНД
              </div>
              {{ !!project.fnd ? project.fnd.code : 'Не назначено' }}
            </div>
          </div>
          <div class="project-info">
            <div class="project-title">
              {{ project.name }}
            </div>
            <div class="project-date">
              {{ stringDateToText(project.created_at) }}
            </div>
          </div>
          <div class="project-responsibles">
            <div class="project-title">
              Ответственные
            </div>
            <div class="responsibles" v-if="!!project.responsible">
              <div class="ccs-tag ccs-tag--normal" v-for="(item, index) in project.responsible.data" :key="index">
                {{ item.full_name }}
              </div>
            </div>
            <div v-else>
              Не назначены
            </div>
          </div>
          <div class="project-responsible_fnd">
            <div class="project-title">
              Ответственный ФНД
            </div>
            {{ !!project.fnd ? project.fnd.code : 'Не назначено' }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters, mapMutations } from 'vuex';

import { getNotificationMessage } from '@/helpers/notification.js';
import AutocompleteParent from '@/mixins/AutocompleteParent.js';
import DateRender from '@/mixins/DateRender.js';

import Header from '@/layouts/Header.vue';
import Input from '@/components/forms/Input.vue';

import DashboardControlPointsPieChartContainer from '@/components/charts/DashboardControlPointsPieChartContainer.vue';

export default {
  name: 'Dashboard',
  mixins: [AutocompleteParent, DateRender],
  components: {
    'ccs-header': Header,
    'ccs-input': Input,
    DashboardControlPointsPieChartContainer,
  },
  data() {
    return {
      eventsForSelect: [],
      mode: 'projects',
      modes: [{
        prop: 'control_points',
        text: 'Контрольные точки'
      }, {
        prop: 'projects',
        text: 'Проекты'
      }],
      dateFormatOptions: {
        day: 'numeric',
        year: 'numeric',
        month: 'numeric',
      },
    };
  },
  computed: {
    ...mapState('dashboard', [
      'control_points',
      'control_points_stats',
      'projects',
      'eventContext',
      'manualNotifications',
      'automatedNotifications'
    ]),
    ...mapGetters('dashboard', [
      'inProgressList',
      'waitingForApprovalList',
      'inClosureProcessList',
      'isEventContext',
      'notifications',
      'relatedToMeControlPointsCount',
      'allControlPointsCount',
    ]),
    contextEventId: {
      get() {
        return this.eventContext;
      },
      set(val) {
        this.setEventContext(val);
      }
    },
  },
  methods: {
    ...mapActions('session', ['getProfile']),
    ...mapActions('dashboard', ['initializeContext', 'updateContext']),
    ...mapActions('misc', ['setDefaultDashboardView']),
    ...mapActions('projects', ['openControlPointByID', 'openNotificationByID']),
    ...mapMutations('dashboard', ['setEventContext']),
    async onEventSearch(text) {
      [this.eventsForSelect] = await this.getAutocompleteData('/v1/events/list', text, 'id', 'short_name');
    },
    onModeSelect() {
      this.setDefaultDashboardView(this.mode);
      if (this.mode === 'control_points') {
        this.$router.replace({ name: 'dashboard_control_points' });
      } else {
        this.$router.replace({ name: 'dashboard_projects' });
      }
      this.getProfile();
      this.updateContext();
    },
    goToProjectPage(project) {
      this.$router.push({ name: 'project', params: { projectID: project.id } });
    },
    getNotificationMessage(notification) {
      return getNotificationMessage(notification);
    }
  },
  async created() {
    if (this.$route.name.indexOf('control_points') !== -1) {
      this.mode = 'control_points';
      if (this.$route.query.control_point) {
        this.openControlPointByID(this.$route.query.control_point);
      }
    }
    const intialEvent = await this.initializeContext();
    if (intialEvent) this.eventsForSelect = [{
      prop: intialEvent.id,
      searchText: intialEvent.short_name,
      displayText: intialEvent.short_name,
    }];
  }
};
</script>

<style lang="scss" scoped>
.dashboard {
  min-width: 100%;
  min-height: 100%;
  background: #fff;

  &-content {
    margin: 0 33px;

    .dashboard {

      &-navbar {
        margin-bottom: 20px;
        display: flex;
        justify-content: flex-start;
        align-items: center;

        .navbar-mode {
          width: auto;
        }

        > div:not(:last-child) {
          margin-right: 20px;
        }

      }

      &-notifications {
        margin-bottom: 40px;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: flex-start;

        &-block {
          margin-bottom: 20px;
          display: flex;
          flex-direction: column;
          justify-content: flex-start;
          align-items: flex-start;

          .block-content {
            max-width: calc(100vw - 180px);
            display: flex;
            flex-direction: row;
            justify-content: flex-start;
            align-items: flex-start;
            overflow-x: scroll;
            scrollbar-width: thin;
            scrollbar-color: $primaryLight $primaryLightest + 50;

            &::-webkit-scrollbar {
              height: 5px;
            }

            &::-webkit-scrollbar-track {
              background: $primaryLightest + 50;
              border-radius: 50px;
            }

            &::-webkit-scrollbar-thumb {
              max-width: 50px;
              background: $primaryLight;
              border-radius: 50px;
            }

          }

        }

        .dashboard {

          &-notification {
            padding: 10px;
            margin-bottom: 15px;
            min-width: 400px;
            max-width: 400px;
            display: flex;
            flex-direction: column;
            justify-content: flex-start;
            align-items: stretch;
            border: 1px solid $primary;
            border-radius: 5px;
            cursor: pointer;

            &:not(:first-child) {
              margin-left: 20px;
            }

            .notification {

              &-row {
                display: flex;
                justify-content: space-between;
                align-items: center;
                flex-wrap: wrap;
                overflow: hidden;

                &:not(:last-child) {
                  margin-bottom: 10px;
                }

                &--message {
                  max-height: 65px;
                  width: 100%;
                  text-overflow: ellipsis;
                  overflow: hidden;
                }

                &--message_short {
                  max-width: 100%;
                  text-overflow: ellipsis;
                  white-space: nowrap;
                  overflow: hidden;
                }

                &--tags {
                  justify-content: flex-start;
                }

              }

            }

          }

        }

      }

      &-control_points {
        max-width: calc(100vw - 240px);
        display: flex;
        flex-direction: row;
        justify-content: stretch;
        align-items: stretch;

        &-stats {
          display: flex;
          margin-bottom: 30px;
        }

        &-block {
          position: relative;
          display: flex;
          flex-direction: column;
          justify-content: flex-start;
          align-items: stretch;

          &:not(:first-child) {
            margin-left: 60px;

            &::before {
              content: '';
              position: absolute;
              left: -39px;
              top: 65px;
              width: 1px;
              height: calc(100% - 85px);
              background-color: $primaryLightest;
            }

          }

          .block-content {
            max-width: 100%;
            margin-left: -10px;
            padding-right: 10px;
            display: flex;
            justify-content: flex-start;
            align-items: stretch;
            flex-wrap: wrap;
          }

        }

        .dashboard {

          &-control_point {
            box-sizing: border-box;
            margin: 10px;
            padding: 10px;
            width: 370px;
            height: 76px;
            display: flex;
            flex-direction: column;
            justify-content: flex-start;
            align-items: stretch;
            border: 1px solid $primary;
            border-radius: 5px;
            cursor: pointer;

            .control_point {

              &-row {
                display: flex;
                justify-content: space-between;
                align-items: center;
                flex-wrap: wrap;
                overflow: hidden;

                &:not(:last-child) {
                  margin-bottom: 10px;
                }

                &--header, &--footer {
                  min-height: 22px;
                }

                &--tags {
                  justify-content: flex-start;
                }

              }

              &-title {
                max-width: 100%;
                margin-bottom: 5px;
                color: $primary;
                text-overflow: ellipsis;
                white-space: nowrap;
                overflow: hidden;
              }

            }

          }

        }

      }

      &-projects {

        .dashboard {

          &-project {
            position: relative;
            box-sizing: border-box;
            margin-bottom: 20px;
            padding: 20px;
            min-height: 100px;
            width: 100%;
            display: flex;
            align-items: stretch;
            border-radius: 5px;
            box-shadow: 0 0 10px rgba(129, 129, 129, 0.2);
            cursor: pointer;

            > div:not(:last-child) {
              margin-right: 30px;
            }

            .project {

              &-responsibles {
                max-width: 305px;
                width: 305px;

                .responsibles {
                  max-width: 305px;
                  width: 305px;
                  display: flex;
                  flex-wrap: wrap;

                  > div {
                    margin: 0 5px 5px 0;
                  }

                }

              }

              &-progress {
                position: absolute;
                box-sizing: border-box;
                top: 0;
                left: 0;
                padding: 20px;
                height: 100%;
                width: 100%;
                display: flex;
                align-items: stretch;
                background: $primary;
                border-radius: 5px;

                > div:not(:last-child) {
                  margin-right: 30px;
                }

                .project-info {

                  .project-title, .project-date {
                    color: #fff;
                  }

                }

                .project-title, .project-description, .project-responsibles, .project-responsible_fnd {
                  color: #fff;
                }

              }

              &-title {
                margin-bottom: 10px;
                color: #000;
                font-size: 12px;
                font-weight: bold;
              }

              &-point {
                margin-bottom: 5px;
                color: $primary;
                font-size: 20px;
                font-weight: bold;
              }

              &-date {
                font-size: 12px;
              }

              &-tansport {
                color: $primaryLighter;
                font-size: 14px;
                font-weight: bold;
              }

              &-description {
                max-width: 25%;
                font-size: 14px;
              }

              &-info {
                width: 400px;
                display: flex;
                flex-direction: column;
                justify-content: space-between;
                align-items: flex-start;

                .project-title {
                  color: $primary;
                  font-size: 16px;
                }

                .project-date {
                  font-size: 16px;
                }

              }

            }

          }

        }

      }

    }

  }

  &-branding {
    color: $primaryLight;
  }

  &-title {
    margin-bottom: 10px;
    font-size: 24px;
    font-weight: bold;
    line-height: 38px;
    color: $primary;
  }

  &-subtitle {
    margin-bottom: 10px;
    font-size: 20px;
    font-weight: bold;
    line-height: 38px;
    color: $surfaceDark;
  }

}
</style>
